import React from 'react';
import { VideoPlugin } from './VideoPlugin';
import styled from 'styled-components';

import WinVideoMp4 from './videos/christmas/win.mp4';
import LoseVideoMp4 from './videos/christmas/lose.mp4';
import LandingVideoMp4 from './videos/christmas/landing.mp4';

import { IProps } from '../../common-types/Prop';

export const VideoContainer = styled.div`
  margin-top: 23.3vh;
  position: relative;
  display: inline-block;
  width: 50vw;
  overflow: hidden;
  height: 57vh;
`;
VideoContainer.displayName = 'VideoContainer';

export const ChristmasPlugin: React.FunctionComponent<IProps> = (props) => (
  <VideoPlugin
    {...props}
    winVideo={{ mp4: WinVideoMp4 }}
    loseVideo={{ mp4: LoseVideoMp4 }}
    landingVideo={{ mp4: LandingVideoMp4 }}
    VideoWrapper={VideoContainer}
  />
);